import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type State = {
  breadcrumbs: Array<{
    title: string,
    link: string,
  }>
};
const initialState: State = { breadcrumbs: [] };

export const breadSlice = createSlice({
  name: 'breadcrumbs',
  initialState,
  reducers: {
    navigate: (state, action: PayloadAction<{ title: string, link: string }>) => {
      const payload = action.payload;
      const i = state.breadcrumbs.findIndex((v) => v.link === payload.link);
      if (i === -1) {
        // Not yet in breadcrumbs, push
        return {
          ...state,
          breadcrumbs: [...state.breadcrumbs, payload],
        };
      } else {
        // Already in payload
        return {
          ...state,
          breadcrumbs: state.breadcrumbs.filter((v, idx) => i >= idx),
        };
      }
    },
  },
})

// Action creators are generated for each case reducer function
export const { navigate } = breadSlice.actions;
export default breadSlice.reducer;